import RequestV2 from "../../../helpers/request-v2"
import {AppConfig} from "../../../config/config"


const {baseUrlOld} = AppConfig.nm_api
const endpoint = `${baseUrlOld}invoiceaccount/update-status`
const saleStatus = {
    OK: 'OK',
    CANCELLED: 'CANCELLED'
}


export function changeSaleStatus(ivaCode, status) {

    return RequestV2
        .getInstance()
        .createGetRequest(endpoint, {ivaCode, status}, {}, false, true)
}


export function approveSale(ivaCode) {
    return changeSaleStatus(ivaCode, saleStatus.OK)
}


export function cancelSale(ivaCode) {
    return changeSaleStatus(ivaCode, saleStatus.CANCELLED)
}





// WEBPACK FOOTER //
// ./src/_pages/Sale/_functions/change-sale-status.js